import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { selectBlackFriday, selectHasBlackFridayPromos } from '../../../selectors/blackFriday';

export const useDesktopBlackFridayActive = () => {
  const { isActive } = useSelector(selectBlackFriday);
  const isDesktop = useDeviceType() === 'desktop';
  const hasBlackFridayPromos = useSelector(selectHasBlackFridayPromos);

  return isActive && isDesktop && hasBlackFridayPromos;
};
